import { Box } from "@mui/material";

export const RequestDemoForm = () => {
  return (
    <Box
      className="hs-form-frame"
      data-region="na1"
      data-form-id="a013b39c-5c56-4679-ab90-56940b2d64d8"
      data-portal-id="20049731"
    ></Box>
  );
};
